export enum TrackingTypes {
  'LOAD_TRACKING_REQUEST' = '@tracking/LOAD_TRACKING_REQUEST',
  'LOAD_TRACKING_SUCCESS' = '@tracking/LOAD_TRACKING_SUCCESS',
  'LOAD_TRACKING_FAILURE' = '@tracking/LOAD_TRACKING_FAILURE',

  'FILTER_TRACKING' = '@tracking/FILTER_TRACKING',
  'CLEAR_TRACKING' = '@tracking/CLEAR_TRACKING',
}

export interface Pagination {
  total: number;
  pageSize: number;
  current: number;
  showSizeChanger: boolean;
  pageSizeOptions: string[];
}
export interface Sorter {
  sortBy: string;
  ascendance: string;
}

export interface Filter {
  filter: object | undefined;
}

export interface FilterTracking {
  numNota: number;
  cidadeDestino: number;
  destinatario: number;
  status: string;
}

export interface Tracking {
  cidadeDestino: string;
  cidadeOrigem: string;
  codObs: string;
  cteDhEmissao: string;
  cteNumNota: number;
  cteNunota: number;
  destinatario: string;
  dtPrevChegada: string;
  dtPrazoAcordado: string;
  localizacao: string;
  nfDhEmissao: string;
  nfNumNota: number;
  nomeTranportadora: string;
  ordemCarga: number;
  placa: string;
  qtdAnexo: number;
  status: string;
  dtSaida: string;
}

export interface TrackingState {
  readonly data: Tracking[];
  readonly loading: boolean;
  readonly error: boolean;
  readonly pagination: Pagination;
  readonly filter?: Filter;
}
